export default __webpack_public_path__ + "static/konkurs_regulamin-ecbb7f3a779393373093aba38f814f1e.pdf";